import React, {useEffect} from 'react'

import template from './slider-3.twig'

import parse from 'html-react-parser'

import legacyJs from './slider-3.legacy'

import {ContentOptions, HeadlineOptions, LinkOptions, Offset} from '@miro-site/components_utils'

export interface Image {
  src: string
  alt: string
}

export interface Item {
  image: Image
}

export interface Slider3Props {
  background?: 'dark' | 'blue' | 'pink' | 'yellow'
  offset?: Offset
  headline?: HeadlineOptions
  content?: ContentOptions
  link?: LinkOptions
  items: Item[]
  children?: React.ReactNode
}

import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'

const Slider3 = (props: Slider3Props): React.ReactElement => {
  useEffect(() => {
    legacyJs.init()
  }, [])

  return <>{parse(template(props))}</>
}

export default Slider3
